import { Route } from 'react-router-dom';
import { createLazyRoute, createRoute } from '@core/router';
import React from 'react';

import { ProfilePredicate } from '@modules/profile/predicate';
import { Predicate } from 'effect';

const module = () => import('./module');

const alertsRoutes = (
  <Route path="alerts" {...createRoute({ restriction: Predicate.not(ProfilePredicate.isSoloPro) })}>
    <Route index {...createLazyRoute(module, m => m.alertsList)} />
    <Route path="new" {...createLazyRoute(module, m => m.createAlert)} />
    <Route path=":id" {...createLazyRoute(module, m => m.updateAlert)} />
  </Route>
);

export default alertsRoutes;
